<template>
  <div class="page-container">
    <div class="sidebar-layout">
      <aside class="sidebar-layout__menu">
        <el-menu :default-active="currentIndex" @select="menuSelect">
          <template v-for="(item, index) in leftMenus" :key="item.id">
            <el-menu-item v-if="!item.children || item.children.length === 0" :index="item.code">
              {{ item.name }}
            </el-menu-item>
            <el-sub-menu v-else :index="String(index)">
              <template #title>{{ item.name }}</template>
              <el-menu-item v-for="subItem in item.children" :key="subItem.id" :index="subItem.code">
                {{ subItem.name }}
              </el-menu-item>
            </el-sub-menu>
          </template>
        </el-menu>
      </aside>
      <div class="sidebar-layout__content">
        <div class="page-card">
          <div class="page-card__header">
            <h1 class="section-title">{{ title }}</h1>
          </div>
          <div class="page-card__body">
            <template v-for="item in tableData" :key="item.id">
              <RouterLink
                v-if="item.content"
                :to="'/detail?id=' + item.id"
                class="news-list-item"
              >
                <div v-if="item.mainImgUrl" class="news-list-item__thumb">
                  <img :src="item.mainImgUrl" :alt="item.title" />
                </div>
                <div class="news-list-item__content">
                  <p class="news-list-item__title">{{ item.title }}</p>
                  <span class="news-list-item__date">{{ item.publishDate }}</span>
                </div>
              </RouterLink>
              <a v-else :href="item.linkUrl" target="_blank" class="news-list-item">
                <div v-if="item.mainImgUrl" class="news-list-item__thumb">
                  <img :src="item.mainImgUrl" :alt="item.title" />
                </div>
                <div class="news-list-item__content">
                  <p class="news-list-item__title">{{ item.title }}</p>
                  <span class="news-list-item__date">{{ item.publishDate }}</span>
                </div>
              </a>
            </template>
            <div v-if="!tableData.length" class="empty-tip">暂无数据</div>
            <div class="pagination-wrap">
              <el-pagination
                background
                layout="prev, pager, next"
                :total="total"
                :current-page="pageNo"
                :page-size="pageSize"
                @current-change="handleCurrentChange"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { informationShow, listInformationMenus } from '@/api/cmsApi'

export default {
  name: 'InformationShow',
  data() {
    return {
      tableData: [],
      pageNo: 1,
      pageSize: 5,
      total: 0,
      currentIndex: '',
      leftMenus: [],
      title: ''
    }
  },
  created() {
    this.init()
  },
  methods: {
    async init() {
      await this.queryLeftMenu()
      await this.menuSelect(this.currentIndex)
    },
    query() {
      informationShow({ pageNo: this.pageNo, pageSize: this.pageSize, type: this.currentIndex }).then(res => {
        if (res.code === 200) {
          this.tableData = res.data.records
          this.total = res.data.total
        }
      })
    },
    async queryLeftMenu() {
      const res = await listInformationMenus()
      if (res.code === 200) {
        this.leftMenus = res.data || []
        if (this.leftMenus.length) {
          this.currentIndex = this.leftMenus[0].code
          this.title = this.leftMenus[0].name
        }
      }
    },
    handleCurrentChange(page) {
      this.pageNo = page
      this.query()
    },
    menuSelect(index) {
      this.leftMenus.forEach(item => {
        if (index === item.code) {
          this.title = item.name
        } else if (item.children) {
          item.children.forEach(sub => {
            if (index === sub.code) this.title = sub.name
          })
        }
      })
      this.currentIndex = index
      this.pageNo = 1
      this.query()
    }
  }
}
</script>

<style scoped>
.sidebar-layout__menu :deep(.el-menu) {
  border-right: none;
}

.sidebar-layout__menu :deep(.el-menu-item.is-active) {
  color: var(--color-primary);
  background: rgba(192, 57, 43, 0.06);
}

.empty-tip {
  text-align: center;
  color: var(--color-text-muted);
  padding: 40px 0;
}
</style>
